module.exports = __webpack_public_path__ + "img/Postmodernisme_Oyvind-Berg.ddec02b1.jpg";